import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { sessionIsUsuarioExterno } from 'src/app/session/store/session.selectors';
import { ManagedLinkKey } from 'src/common/managedLinkKey';

@Component({
	selector: 'general',
	templateUrl: './general.component.html',
	styleUrls: ['./general.component.scss']
})
export class GeneralComponent {

	recursosHumanosKey: ManagedLinkKey = ManagedLinkKey.RECURSOS_HUMANOS;
	misCursosKey: ManagedLinkKey = ManagedLinkKey.MIS_CURSOS;
	selfServiceKey: ManagedLinkKey = ManagedLinkKey.SELF_SERVICE;

	isUsuarioExterno$: Observable<boolean>;

	constructor( private store: Store<AppState> ) {
		this.isUsuarioExterno$ = this.store.select( sessionIsUsuarioExterno );
	}

}
